/**
 * Arabic translations for property requests page.
 * Used by individuals tracking their listing requests through Safaqat24's FAL license.
 */

const propertyRequests = {
  // Page header
  title: 'طلباتي العقارية',
  subtitle: 'تتبع حالة طلبات إدراج عقاراتك',
  newRequest: 'طلب جديد',

  // Status labels
  status: {
    draft: 'مسودة',
    pending: 'قيد المراجعة',
    approved: 'تمت الموافقة',
    rejected: 'مرفوض',
    listed: 'منشور',
    completed: 'مكتمل',
  },

  // Listing type
  listingType: {
    sale: 'للبيع',
    rent: 'للإيجار',
  },

  // Request details
  description: 'الوصف',
  expectedPrice: 'السعر المتوقع',
  contact: 'معلومات التواصل',
  specifications: 'المواصفات',
  bedrooms: 'غرف نوم',
  bathrooms: 'دورات مياه',
  sqm: 'م\u00B2',
  sar: 'ريال',
  negotiable: 'قابل للتفاوض',

  // Timeline
  submitted: 'تاريخ التقديم',
  reviewed: 'تاريخ المراجعة',
  rejectionReason: 'سبب الرفض',

  // Actions
  viewListing: 'عرض الإعلان',
  contactToEdit: 'تواصل معنا لإجراء تغييرات',

  // Empty state
  empty: {
    title: 'لا توجد طلبات بعد',
    description:
      'قدم طلب إدراج عقاري وتتبع حالته هنا. سيتم إدراج عقارك تحت رخصة صفقات 24.',
    cta: 'تقديم طلب',
  },

  // Info box
  info: 'بمجرد الموافقة، سيتم إدراج عقارك تحت رخصة صفقات 24. ستتلقى إشعاراً عند نشر إعلانك.',

  // Error states
  error: {
    notLoggedIn: 'يرجى تسجيل الدخول لعرض طلباتك',
    loadFailed: 'فشل تحميل طلباتك. يرجى المحاولة مرة أخرى.',
    retry: 'إعادة المحاولة',
  },
};

export default propertyRequests;
